import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";

function intArrToFlags(intArr) {
    if (Array.isArray(intArr)) {
        return intArr.reduce((sum, flag) => sum | flag, 0);
    } else if (typeof intArr === 'number') {
        return intArr;
    } else {
        return 0;
    }
}

export default {
    methods: {
        async getWebhookSubscriptionList(filter) {
            var meta = { clientApiMethod: 'getWebhookSubscriptionList', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "WebhookSubscription", { params: filter, meta: meta })
            return response?.data;
        },
        async getWebhookSubscription(id) {
            var meta = { clientApiMethod: 'getWebhookSubscription', input: { id: id } }
            var response = await client().get(store.state.apiRouteRoot + "WebhookSubscription/" + id, { meta: meta })
            return response?.data;
        },
        async createWebhookSubscription(newWebhookSubscription) {
            // Convert ActionFlags from array to number using bitwise OR before sending
            var payload = { ...newWebhookSubscription };
            payload.ActionFlags = intArrToFlags(payload.ActionFlags);
            var meta = {
                clientApiMethod: 'createWebhookSubscription',
                input: { newWebhookSubscription: payload },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.webhook_subscription.webhook_subscription") })
            }
            var response = await client().post(store.state.apiRouteRoot + 'WebhookSubscription', payload, { meta: meta })
            return response?.data;
        },
        async changeWebhookSubscription(updatedWebhookSubscription) {
            // Convert ActionFlags from array to number using bitwise OR before sending
            var payload = { ...updatedWebhookSubscription };
            payload.ActionFlags = intArrToFlags(payload.ActionFlags);
            var meta = {
                clientApiMethod: 'changeWebhookSubscription',
                input: { updatedWebhookSubscription: payload },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.webhook_subscription.webhook_subscription") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'WebhookSubscription', payload, { meta: meta })
            return response?.data;
        },
        async deleteWebhookSubscription(webhookSubscriptionId) {
            var meta = {
                clientApiMethod: 'deleteWebhookSubscription',
                input: { webhookSubscriptionId: webhookSubscriptionId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.webhook_subscription.webhook_subscription") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "WebhookSubscription/" + webhookSubscriptionId, { meta: meta })
            return response?.data;
        }
    }
}
